/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In everyday lab use they are used interchangeably. Strictly, molecular weight is a dimensionless relative mass and molar mass carries units of g/mol, but the numerical value is the same.`)
};

const es_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el uso cotidiano de laboratorio se usan indistintamente. Estrictamente, el peso molecular es una masa relativa adimensional y la masa molar tiene unidades de g/mol, pero el valor numérico es el mismo.`)
};

const de_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im alltäglichen Laborgebrauch werden sie synonym verwendet. Streng genommen ist das Molekulargewicht eine dimensionslose relative Masse und die molare Masse trägt die Einheit g/mol, aber der Zahlenwert ist derselbe.`)
};

const nl_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In het dagelijkse labgebruik worden ze door elkaar gebruikt. Strikt genomen is molecuulgewicht een dimensieloze relatieve massa en heeft molaire massa de eenheid g/mol, maar de numerieke waarde is hetzelfde.`)
};

const fr_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans l'usage courant en laboratoire, les deux termes sont utilisés indifféremment. Strictement, la masse moléculaire est une masse relative sans dimension et la masse molaire porte l'unité g/mol, mais la valeur numérique est la même.`)
};

const it_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nell'uso quotidiano di laboratorio sono usati in modo intercambiabile. In senso stretto, il peso molecolare è una massa relativa adimensionale mentre la massa molare ha unità g/mol, ma il valore numerico è lo stesso.`)
};

const pt_br2_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No uso cotidiano de laboratório, os termos são usados de forma intercambiável. Estritamente, peso molecular é uma massa relativa adimensional e massa molar tem unidades de g/mol, mas o valor numérico é o mesmo.`)
};

const pt_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No uso laboratorial do dia a dia são usadas como sinónimos. Rigorosamente, a massa molecular é uma massa relativa adimensional e a massa molar tem unidades de g/mol, mas o valor numérico é o mesmo.`)
};

const ja_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実験室での日常的な使用では同じ意味で使われます。厳密には分子量は無次元の相対質量で、モル質量はg/molという単位を持ちますが、数値は同じです。`)
};

const zh_mw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在日常实验室使用中两者可互换使用。严格来说，分子量是无量纲的相对质量，而摩尔质量带有 g/mol 的单位，但数值相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_a4", locale)
	if (locale === "en") return en_mw_faq_a4(inputs)
	if (locale === "es") return es_mw_faq_a4(inputs)
	if (locale === "de") return de_mw_faq_a4(inputs)
	if (locale === "nl") return nl_mw_faq_a4(inputs)
	if (locale === "fr") return fr_mw_faq_a4(inputs)
	if (locale === "it") return it_mw_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_a4(inputs)
	if (locale === "pt") return pt_mw_faq_a4(inputs)
	if (locale === "ja") return ja_mw_faq_a4(inputs)
	return zh_mw_faq_a4(inputs)
};